(function() {
  function loadSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
  }

  function initCustomSlider() {
    const sections = document.querySelectorAll('#shopify-section-template--24930608054556__custom_banner_image_A6xkNB .bls__section');
  sections.forEach(section => {
      const container = section.querySelector('#shopify-section-template--24930608054556__custom_banner_image_A6xkNB .section-full');
      const wrapper = section.querySelector('#shopify-section-template--24930608054556__custom_banner_image_A6xkNB .row');
      const slides = section.querySelectorAll('#shopify-section-template--24930608054556__custom_banner_image_A6xkNB .bls__banner-item');
    
      if (!container || !wrapper || slides.length === 0) return;

      // Setup Classes
      container.classList.add('swiper', 'pro-banner-slider');
      wrapper.classList.add('swiper-wrapper');
      wrapper.classList.remove('row'); 
      
      slides.forEach(slide => {
        slide.classList.add('swiper-slide');
        slide.style.width = '100%'; 
        slide.style.maxWidth = '100%';
        slide.style.flex = '0 0 auto';
      });

      // Create Navigation Elements
    //   const nextBtn = document.createElement('div');
    //   nextBtn.className = 'swiper-button-next custom-swiper-next';
      
    //   const prevBtn = document.createElement('div');
    //   prevBtn.className = 'swiper-button-prev custom-swiper-prev';
      
    //   const pagination = document.createElement('div');
    //   pagination.className = 'swiper-pagination custom-swiper-pagination';

    //   container.appendChild(nextBtn);
    //   container.appendChild(prevBtn);
    //   container.appendChild(pagination);

      // Initialize Swiper
      new Swiper(container, {
        effect: 'slide', // Standard sliding effect
        speed: 1200,      // Smooth slide speed
        loop: true,     // STOPS at the beginning and end
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          stopOnLastSlide: true // Stops autoplaying when it hits the end
        },
        pagination: {
          el: '.swiper-pagination',
         clickable: true, 
        },
        // navigation: {
        //   nextEl: nextBtn,
        //   prevEl: prevBtn,
        // },
        // pagination: {
        //   el: pagination,
        //   clickable: true,
        // },
        on: {
          init: function() {
            section.classList.add('slider-loaded');
          }
        }
    });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    loadSwiper(initCustomSlider);
  });
})();